export default __webpack_public_path__ + "static/media/img-gt-mode-gt-bg-kr_kr@2x.34d4f7ca.jpg";